export const getPlantCharacteristics = (plantType) => {
  const characteristics = {
    'Blue Dream': {
      // Visual characteristics
      leafHue: 0.55,
      budHue: 0.6,
      stemColor: 0x2d5a3d,
      leafShape: 'standard',
      height: 1.0,
      leafSize: 1.0,
      budDensity: 1.0,
      leafFingers: 7,
      specialFeatures: ['blue_tint'],
      
      // Growth & Environmental Preferences
      growthRate: 1.0,
      waterNeeds: 'medium',
      lightNeeds: 'medium',
      soilNeeds: 'medium',
      resilience: 0.8,
      stageThresholds: [0.15, 0.35, 0.6, 0.90],
      
      waterTolerance: 25,
      lightTolerance: 20,
      soilTolerance: 30,
      
      idealWater: 70,
      idealLight: 75,
      idealSoil: 80,
      
      perfectConditionBonus: 1.2,
      
      traits: ['balanced', 'beginner_friendly']
    },
    
    'Green Crack': {
      // Visual characteristics
      leafHue: 0.25,
      budHue: 0.15,
      stemColor: 0x2d5a2d,
      leafShape: 'spiky',
      height: 0.8,
      leafSize: 0.7,
      budDensity: 0.9,
      leafFingers: 5,
      specialFeatures: ['bright_green', 'compact'],
      
      // Growth & Environmental Preferences
      growthRate: 1.3,
      waterNeeds: 'medium',
      lightNeeds: 'medium',
      soilNeeds: 'low',
      resilience: 0.9,
      stageThresholds: [0.15, 0.35, 0.6, 0.95],
      
      waterTolerance: 25,
      lightTolerance: 25,
      soilTolerance: 25,
      
      idealWater: 60,
      idealLight: 70,
      idealSoil: 65,
      
      perfectConditionBonus: 1.4,
      
      traits: ['fast_growing', 'compact', 'energetic']
    },
    
    'Northern Lights': {
      // Visual characteristics
      leafHue: 0.3,
      budHue: 0.25,
      stemColor: 0x3d5a3d,
      leafShape: 'wide',
      height: 0.9,
      leafSize: 1.2,
      budDensity: 1.4,
      leafFingers: 7,
      specialFeatures: ['aurora_shimmer', 'thick_buds'],
      
      // Growth & Environmental Preferences
      growthRate: 0.9,
      waterNeeds: 'medium',
      lightNeeds: 'low',
      soilNeeds: 'medium',
      resilience: 0.95,
      stageThresholds: [0.25, 0.5, 0.75, 0.90],
      
      waterTolerance: 30,
      lightTolerance: 35,
      soilTolerance: 30,
      
      idealWater: 65,
      idealLight: 60,
      idealSoil: 75,
      
      perfectConditionBonus: 1.3,
      
      traits: ['hardy', 'indica', 'low_light']
    },
    
    'Jack Herer': {
      // Visual characteristics
      leafHue: 0.28,
      budHue: 0.2,
      stemColor: 0x2d4a2d,
      leafShape: 'classic',
      height: 1.2,
      leafSize: 1.0,
      budDensity: 1.1,
      leafFingers: 7,
      specialFeatures: ['forest_green', 'sturdy'],
      
      // Growth & Environmental Preferences
      growthRate: 1.0,
      waterNeeds: 'medium',
      lightNeeds: 'medium',
      soilNeeds: 'medium',
      resilience: 0.85,
      stageThresholds: [0.25, 0.5, 0.75, 0.90],
      
      waterTolerance: 25,
      lightTolerance: 25,
      soilTolerance: 25,
      
      idealWater: 75,
      idealLight: 80,
      idealSoil: 85,
      
      perfectConditionBonus: 1.25,
      
      traits: ['reliable', 'consistent', 'sturdy']
    },
    
    'White Widow': {
      // Visual characteristics
      leafHue: 0.3,
      budHue: 0.1,
      stemColor: 0x3d5a3d,
      leafShape: 'serrated',
      height: 1.1,
      leafSize: 0.9,
      budDensity: 1.5,
      leafFingers: 5,
      specialFeatures: ['white_crystals', 'dense_buds'],
      
      // Growth & Environmental Preferences
      growthRate: 1.1,
      waterNeeds: 'high',
      lightNeeds: 'high',
      soilNeeds: 'high',
      resilience: 0.6,
      stageThresholds: [0.25, 0.55, 0.85, 0.90],
      
      waterTolerance: 15,
      lightTolerance: 15,
      soilTolerance: 15,
      
      idealWater: 85,
      idealLight: 90,
      idealSoil: 90,
      
      perfectConditionBonus: 1.5,
      
      traits: ['high_yield', 'demanding', 'premium']
    },
    
    'Purple Haze': {
      // Visual characteristics
      leafHue: 0.75,
      budHue: 0.8,
      stemColor: 0x4a2c4a,
      leafShape: 'narrow',
      height: 1.3,
      leafSize: 0.8,
      budDensity: 0.8,
      leafFingers: 7,
      specialFeatures: ['purple_leaves', 'haze_effect'],
      
      // Growth & Environmental Preferences
      growthRate: 0.9,
      waterNeeds: 'medium',
      lightNeeds: 'high',
      soilNeeds: 'medium',
      resilience: 0.7,
      stageThresholds: [0.35, 0.65, 0.90, 0.95],
      
      waterTolerance: 20,
      lightTolerance: 10,
      soilTolerance: 25,
      
      idealWater: 65,
      idealLight: 95,
      idealSoil: 75,
      
      perfectConditionBonus: 1.3,
      
      traits: ['artistic', 'light_dependent', 'colorful']
    },
    
    'Pineapple Express': {
      // Visual characteristics
      leafHue: 0.35,
      budHue: 0.08,
      stemColor: 0x3d4a2d,
      leafShape: 'tropical',
      height: 1.0,
      leafSize: 1.1,
      budDensity: 1.3,
      leafFingers: 7,
      specialFeatures: ['tropical_colors', 'golden_buds'],
      
      // Growth & Environmental Preferences
      growthRate: 1.1,
      waterNeeds: 'high',
      lightNeeds: 'high',
      soilNeeds: 'medium',
      resilience: 0.75,
      stageThresholds: [0.2, 0.45, 0.7, 0.930],
      
      waterTolerance: 20,
      lightTolerance: 15,
      soilTolerance: 25,
      
      idealWater: 85,
      idealLight: 90,
      idealSoil: 80,
      
      perfectConditionBonus: 1.4,
      
      traits: ['tropical', 'humidity_loving', 'exotic']
    },
    
    'Sour Diesel': {
      // Visual characteristics
      leafHue: 0.18,
      budHue: 0.12,
      stemColor: 0x5a4d2d,
      leafShape: 'elongated',
      height: 1.4,
      leafSize: 1.1,
      budDensity: 1.2,
      leafFingers: 9,
      specialFeatures: ['yellow_tint', 'tall', 'diesel_shimmer'],
      
      // Growth & Environmental Preferences
      growthRate: 0.7,
      waterNeeds: 'high',
      lightNeeds: 'high',
      soilNeeds: 'high',
      resilience: 0.5,
      stageThresholds: [0.4, 0.65, 0.85, 0.95],
      
      waterTolerance: 10,
      lightTolerance: 10,
      soilTolerance: 10,
      
      idealWater: 90,
      idealLight: 95,
      idealSoil: 95,
      
      perfectConditionBonus: 2.0,
      
      traits: ['legendary', 'perfectionist', 'rewarding']
    },
    
    'Girl Scout Cookies': {
      // Visual characteristics
      leafHue: 0.45,
      budHue: 0.15,
      stemColor: 0x4a3d2d,
      leafShape: 'rounded',
      height: 0.9,
      leafSize: 0.9,
      budDensity: 1.4,
      leafFingers: 5,
      specialFeatures: ['sweet_crystals', 'golden_hue'],
      
      // Growth & Environmental Preferences
      growthRate: 0.8,
      waterNeeds: 'high',
      lightNeeds: 'high',
      soilNeeds: 'high',
      resilience: 0.55,
      stageThresholds: [0.35, 0.6, 0.8, 0.95],
      
      waterTolerance: 12,
      lightTolerance: 12,
      soilTolerance: 12,
      
      idealWater: 88,
      idealLight: 92,
      idealSoil: 95,
      
      perfectConditionBonus: 1.8,
      
      traits: ['sweet', 'demanding', 'award_winning']
    },
    
    'OG Kush': {
      // Visual characteristics
      leafHue: 0.32,
      budHue: 0.22,
      stemColor: 0x3d4a3d,
      leafShape: 'classic',
      height: 1.0,
      leafSize: 1.1,
      budDensity: 1.3,
      leafFingers: 7,
      specialFeatures: ['royal_crown', 'diamond_crystals'],
      
      // Growth & Environmental Preferences
      growthRate: 0.85,
      waterNeeds: 'high',
      lightNeeds: 'medium',
      soilNeeds: 'high',
      resilience: 0.65,
      stageThresholds: [0.3, 0.55, 0.8, 0.92],
      
      waterTolerance: 18,
      lightTolerance: 20,
      soilTolerance: 15,
      
      idealWater: 82,
      idealLight: 85,
      idealSoil: 92,
      
      perfectConditionBonus: 1.6,
      
      traits: ['legendary', 'west_coast', 'high_yield']
    },
    
    'Gorilla Glue #4': {
      // Visual characteristics
      leafHue: 0.22,
      budHue: 0.18,
      stemColor: 0x2d3d2d,
      leafShape: 'broad',
      height: 1.2,
      leafSize: 1.3,
      budDensity: 1.6,
      leafFingers: 9,
      specialFeatures: ['sticky_resin', 'gorilla_strength'],
      
      // Growth & Environmental Preferences
      growthRate: 0.6,
      waterNeeds: 'high',
      lightNeeds: 'high',
      soilNeeds: 'high',
      resilience: 0.45,
      stageThresholds: [0.45, 0.7, 0.88, 0.95],
      
      waterTolerance: 8,
      lightTolerance: 8,
      soilTolerance: 8,
      
      idealWater: 95,
      idealLight: 98,
      idealSoil: 98,
      
      perfectConditionBonus: 2.2,
      
      traits: ['exotic', 'ultra_potent', 'sticky']
    },
    
    'Blue Moonshine': {
      // Visual characteristics
      leafHue: 0.65,
      budHue: 0.7,
      stemColor: 0x2d2d5a,
      leafShape: 'mystical',
      height: 1.1,
      leafSize: 0.9,
      budDensity: 1.2,
      leafFingers: 7,
      specialFeatures: ['blue_shimmer', 'moon_glow'],
      
      // Growth & Environmental Preferences
      growthRate: 0.5,
      waterNeeds: 'medium',
      lightNeeds: 'low',
      soilNeeds: 'high',
      resilience: 0.4,
      stageThresholds: [0.5, 0.75, 0.9, 0.98],
      
      waterTolerance: 15,
      lightTolerance: 30,
      soilTolerance: 10,
      
      idealWater: 75,
      idealLight: 40,
      idealSoil: 95,
      
      perfectConditionBonus: 2.5,
      
      traits: ['nocturnal', 'mystical', 'moon_dependent']
    },
    
    'Golden Goat': {
      // Visual characteristics
      leafHue: 0.12,
      budHue: 0.08,
      stemColor: 0x5a4d2d,
      leafShape: 'golden',
      height: 1.3,
      leafSize: 1.0,
      budDensity: 1.1,
      leafFingers: 7,
      specialFeatures: ['golden_leaves', 'sun_blessed'],
      
      // Growth & Environmental Preferences
      growthRate: 0.75,
      waterNeeds: 'medium',
      lightNeeds: 'high',
      soilNeeds: 'high',
      resilience: 0.6,
      stageThresholds: [0.4, 0.65, 0.85, 0.95],
      
      waterTolerance: 20,
      lightTolerance: 12,
      soilTolerance: 15,
      
      idealWater: 78,
      idealLight: 95,
      idealSoil: 90,
      
      perfectConditionBonus: 2.0,
      
      traits: ['golden', 'sun_loving', 'colorado_genetics']
    }
  };
  
  return characteristics[plantType] || characteristics['Blue Dream'];
};
// Enhanced plant state update system that considers strain characteristics
export const updatePlantWithStrainLogic = (plant, plantId, updatePlantVisual, addNotification) => {
  const characteristics = getPlantCharacteristics(plant.plantType);
  
  // Calculate environmental stress/bonus
  const waterDeviation = Math.abs(plant.waterLevel - characteristics.idealWater);
  const lightDeviation = Math.abs(plant.lightLevel - characteristics.idealLight);
  const soilDeviation = Math.abs(plant.soilQuality - characteristics.idealSoil);
  
  // Check if conditions are within tolerance
  const waterStress = Math.max(0, waterDeviation - characteristics.waterTolerance) / 100;
  const lightStress = Math.max(0, lightDeviation - characteristics.lightTolerance) / 100;
  const soilStress = Math.max(0, soilDeviation - characteristics.soilTolerance) / 100;
  
  // Calculate total environmental stress
  const totalStress = (waterStress + lightStress + soilStress) / 3;
  
  // Check if conditions are perfect (within 5 points of ideal)
  const isPerfectWater = Math.abs(plant.waterLevel - characteristics.idealWater) <= 5;
  const isPerfectLight = Math.abs(plant.lightLevel - characteristics.idealLight) <= 5;
  const isPerfectSoil = Math.abs(plant.soilQuality - characteristics.idealSoil) <= 5;
  const isPerfectConditions = isPerfectWater && isPerfectLight && isPerfectSoil;
  
  // Calculate growth multiplier
  let growthMultiplier = characteristics.growthRate;
  
  // Apply perfect condition bonus
  if (isPerfectConditions) {
    growthMultiplier *= characteristics.perfectConditionBonus;
  }
  
  // Apply stress penalties (resilience helps reduce stress impact)
  const stressPenalty = totalStress * (1 - characteristics.resilience);
  growthMultiplier *= Math.max(0.1, 1 - stressPenalty); // Never go below 10% growth
  
  // Apply growth if conditions are decent
  const minimumConditionsToGrow = plant.health > 60 && plant.waterLevel > 30;
  
  if (minimumConditionsToGrow) {
    const baseGrowthIncrease = 0.01; // Base growth per update
    const actualGrowthIncrease = baseGrowthIncrease * growthMultiplier;
    
    plant.growth = Math.min(1, plant.growth + actualGrowthIncrease);
    
    // Check for stage advancement using strain-specific thresholds
    const currentStageThreshold = characteristics.stageThresholds[plant.stage];
    
    if (plant.growth >= currentStageThreshold && plant.stage < 3) {
      plant.stage++;
      plant.growth = characteristics.stageThresholds[plant.stage - 1] || 0.3; // Reset to previous stage threshold
      
      // Special notifications for different strains
      const strainMessages = {
        'Sour Diesel': `🔥 Your legendary ${plant.plantType} has evolved! Stage ${plant.stage + 1}!`,
        'White Widow': `❄️ Your premium ${plant.plantType} has grown beautifully! Stage ${plant.stage + 1}!`,
        'Green Crack': `⚡ Your speedy ${plant.plantType} has advanced quickly! Stage ${plant.stage + 1}!`,
        'Northern Lights': `🌟 Your hardy ${plant.plantType} has grown steadily! Stage ${plant.stage + 1}!`,
        'Purple Haze': `🟣 Your artistic ${plant.plantType} shows beautiful colors! Stage ${plant.stage + 1}!`
      };
      
      const message = strainMessages[plant.plantType] || 
                     `🌱 ${plant.plantType} has grown to stage ${plant.stage + 1}!`;
      
      addNotification(message);
    }
  }
  
  // Strain-specific health calculations
  let healthChange = 0;
  
  // Water impact varies by strain
  const waterImpact = getEnvironmentalImpact(plant.waterLevel, characteristics.idealWater, characteristics.waterTolerance, characteristics.waterNeeds);
  const lightImpact = getEnvironmentalImpact(plant.lightLevel, characteristics.idealLight, characteristics.lightTolerance, characteristics.lightNeeds);
  const soilImpact = getEnvironmentalImpact(plant.soilQuality, characteristics.idealSoil, characteristics.soilTolerance, characteristics.soilNeeds);
  
 const averageImpact = (waterImpact + lightImpact + soilImpact) / 3;

    // FIXED: Resilience should REDUCE penalties, not reduce bonuses
    if (averageImpact < 0) {
    // For negative impacts (stress), resilience reduces the penalty
    healthChange = averageImpact * (1 - characteristics.resilience);
    } else {
    // For positive impacts (good conditions), apply normally
    healthChange = averageImpact;
    }

    plant.health = Math.max(0, Math.min(100, plant.health + healthChange));

    // FIXED CRITICAL CONDITION PENALTIES: Scale by strain characteristics
    let criticalPenalty = 0;

    if (plant.waterLevel <= 10) {
    // Base penalty varies by water needs
    const basePenalty = characteristics.waterNeeds === 'high' ? 3.0 : 
                        characteristics.waterNeeds === 'medium' ? 2.0 : 1.0;
    // Resilience significantly reduces penalty (hardy strains survive droughts!)
    const actualPenalty = basePenalty * (1 - characteristics.resilience * 0.8);
    criticalPenalty += actualPenalty;
    } else if (plant.waterLevel <= 20) {
    // Milder penalty for very low water
    const basePenalty = characteristics.waterNeeds === 'high' ? 1.5 : 
                        characteristics.waterNeeds === 'medium' ? 0.8 : 0.3;
    const actualPenalty = basePenalty * (1 - characteristics.resilience * 0.6);
    criticalPenalty += actualPenalty;
    }

    // Light penalties (less critical than water)
    if (plant.lightLevel <= 30) {
    const basePenalty = characteristics.lightNeeds === 'high' ? 1.0 : 0.5;
    const actualPenalty = basePenalty * (1 - characteristics.resilience * 0.7);
    criticalPenalty += actualPenalty;
    }

    // Apply critical penalties
    plant.health = Math.max(0, plant.health - criticalPenalty);

  // Update attention needs based on strain preferences
  plant.needsAttention = needsAttentionCheck(plant, characteristics);
  
  // Apply strain-specific degradation rates
  applyStrainSpecificDegradation(plant, characteristics);
  
  // Update visual
  updatePlantVisual(plantId, plant.health);
  
  // Special notifications for extreme conditions
  if (isPerfectConditions && Math.random() < 0.05) { // 5% chance per update
    const perfectMessages = {
      'Sour Diesel': '🔥 Your Sour Diesel is thriving in perfect conditions!',
      'White Widow': '❄️ Your White Widow is producing amazing crystals!',
      'Purple Haze': '🟣 The perfect light is bringing out stunning purple colors!',
      'Pineapple Express': '🍍 Your tropical paradise is paying off!',
      'Northern Lights': '🌟 Your hardy Northern Lights loves these conditions!'
    };
    
    if (perfectMessages[plant.plantType]) {
      addNotification(perfectMessages[plant.plantType]);
    }
  }
  
  return plant;
};

// Calculate environmental impact based on strain preferences
const getEnvironmentalImpact = (currentLevel, idealLevel, tolerance, needsLevel) => {
  const deviation = Math.abs(currentLevel - idealLevel);
  
  if (deviation <= 5) {
    // Perfect conditions - bonus based on needs level
    const needsMultiplier = needsLevel === 'high' ? 0.3 : needsLevel === 'medium' ? 0.2 : 0.1;
    return needsMultiplier;
  } else if (deviation <= tolerance) {
    // Good conditions - small bonus
    return 0.1;
  } else {
    // Poor conditions - penalty scales with how far off we are
    const stressFactor = (deviation - tolerance) / 100;
    const needsPenalty = needsLevel === 'high' ? 2.0 : needsLevel === 'medium' ? 1.5 : 1.0;
    return -stressFactor * needsPenalty;
  }
};

// Check if plant needs attention based on strain characteristics
const needsAttentionCheck = (plant, characteristics) => {
  const waterBelowIdeal = plant.waterLevel < (characteristics.idealWater - characteristics.waterTolerance);
  const lightBelowIdeal = plant.lightLevel < (characteristics.idealLight - characteristics.lightTolerance);
  const soilBelowIdeal = plant.soilQuality < (characteristics.idealSoil - characteristics.soilTolerance);
  
  // High-needs strains need attention sooner
  const healthThreshold = characteristics.resilience > 0.8 ? 60 : 70;
  const healthBelowThreshold = plant.health < healthThreshold;
  
  return waterBelowIdeal || lightBelowIdeal || soilBelowIdeal || healthBelowThreshold;
};

// Apply strain-specific resource degradation
export const applyStrainSpecificDegradation = (plant, characteristics) => {
  const degradationMultiplier = {
    high: 1.5,
    medium: 1.0,
    low: 0.7
  };

  // Resource decay
  const waterDegradation = 0.5 * degradationMultiplier[characteristics.waterNeeds];
  const lightDegradation = 0.3 * degradationMultiplier[characteristics.lightNeeds];
  const soilDegradation = 0.4 * degradationMultiplier[characteristics.soilNeeds];

  plant.waterLevel = Math.max(0, plant.waterLevel - waterDegradation);
  plant.lightLevel = Math.max(60, plant.lightLevel - lightDegradation);
  plant.soilQuality = Math.max(50, plant.soilQuality - soilDegradation);

  // ✨ Health degradation — NEW LOGIC
  const waterDeviation = Math.abs(plant.waterLevel - characteristics.idealWater);
  const lightDeviation = Math.abs(plant.lightLevel - characteristics.idealLight);
  const soilDeviation = Math.abs(plant.soilQuality - characteristics.idealSoil);

  const tolerance = {
    water: characteristics.waterTolerance || 10,
    light: characteristics.lightTolerance || 10,
    soil: characteristics.soilTolerance || 10,
  };

  let penalty = 0;

  if (waterDeviation > tolerance.water) {
    penalty += (waterDeviation - tolerance.water) * 0.03; // 👈 slow health effect
  }
  if (lightDeviation > tolerance.light) {
    penalty += (lightDeviation - tolerance.light) * 0.025;
  }
  if (soilDeviation > tolerance.soil) {
    penalty += (soilDeviation - tolerance.soil) * 0.02;
  }

  // Optional cap on penalty per tick
  const maxPenalty = 1.0;
  const totalPenalty = Math.min(penalty, maxPenalty);

  plant.health = Math.max(0, plant.health - totalPenalty);
};
// Enhanced tool effectiveness based on strain preferences
export const getToolEffectiveness = (tool, plantType) => {
  const characteristics = getPlantCharacteristics(plantType);
  
  const toolEffectiveness = {
    'water': {
      baseAmount: 30,
      multiplier: characteristics.waterNeeds === 'high' ? 1.2 : 
                 characteristics.waterNeeds === 'low' ? 0.8 : 1.0
    },
    'light': {
      baseAmount: 25,
      multiplier: characteristics.lightNeeds === 'high' ? 1.3 : 
                 characteristics.lightNeeds === 'low' ? 0.7 : 1.0
    },
    'rake': {
      baseAmount: 20,
      multiplier: characteristics.soilNeeds === 'high' ? 1.2 : 
                 characteristics.soilNeeds === 'low' ? 0.8 : 1.0
    },
    'fertilize': {
      healthBonus: 15,
      soilBonus: 10,
      multiplier: characteristics.resilience < 0.7 ? 1.3 : 1.0 // Sensitive strains benefit more
    }
  };
  
  return toolEffectiveness[tool] || { baseAmount: 0, multiplier: 1.0 };
};

// Get strain-specific tooltip information
export const getStrainTooltipInfo = (plant, characteristics) => {
  const traitDescriptions = {
    'balanced': 'Good all-around performer',
    'beginner_friendly': 'Forgiving and easy to grow',
    'hardy': 'Resistant to poor conditions',
    'cold_resistant': 'Handles temperature drops well',
    'low_maintenance': 'Requires minimal care',
    'high_yield': 'Produces lots of buds when happy',
    'demanding': 'Needs perfect conditions to thrive',
    'premium': 'Rewards careful cultivation',
    'artistic': 'Grown for unique appearance',
    'light_dependent': 'Colors depend on light levels',
    'colorful': 'Shows beautiful purple hues',
    'fast_growing': 'Grows faster than average',
    'compact': 'Stays small and tight',
    'energetic': 'Vigorous growth patterns',
    'legendary': 'Extremely rare and valuable',
    'perfectionist': 'Only thrives in perfect conditions',
    'rewarding': 'Amazing results when done right',
    'reliable': 'Consistent and dependable',
    'consistent': 'Stable growth patterns',
    'sturdy': 'Strong stems and structure',
    'tropical': 'Loves warm, humid conditions',
    'humidity_loving': 'Thrives in high moisture',
    'exotic': 'Unique tropical characteristics'
  };
  
  const primaryTrait = characteristics.traits[0];
  const traitDescription = traitDescriptions[primaryTrait] || 'Unique characteristics';
  
  const needsDescription = `Needs: ${characteristics.waterNeeds} water, ${characteristics.lightNeeds} light, ${characteristics.soilNeeds} soil`;
  
  return {
    traitDescription,
    needsDescription,
    growthRate: characteristics.growthRate,
    resilience: characteristics.resilience
  };
};